import { ACCOUNT_TYPE, fetchUserData, selectUserData } from '../accountSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import { LOCATION_STATES, STATUS } from 'utils/constants'
import useTranslation from 'hooks/useTranslation'
import { useHistory } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
import { displayPrice } from 'utils/string'
import React, { useEffect } from 'react'
import { toLongDate } from 'utils/date'
import Error from 'components/Error'
interface PaymentHistoryProps {
  full?: boolean
  mag?: string
}

export interface PaymentHistoryItem {
  object: string
  id: string
  title: string
  amount: string
  date: string
  receiverBankAccNumber?: string
  receiverCompanyName: string
  receiverCompanyNip: string
  paymentMethodName: string
  paymentMethodKey: string
  status: string
  statusDate: string
  invoices?: PaymentHistoryItemInvoice[]
}

interface PaymentHistoryItemInvoice {
  amount: string
  number: string
  title: string
  link?: string
}

const type = ACCOUNT_TYPE.payments
const PaymentHistory: React.FC<PaymentHistoryProps> = () => {
  const { data } = useReduxSelector(state => selectUserData(state, type))
  const { status = STATUS.idle } = useReduxSelector(state => selectUserData(state, type))

  const { t, lang } = useTranslation('account')
  const { push } = useHistory()
  const dispatch = useReduxDispatch()

  useEffect(() => {
    dispatch(fetchUserData(type))
  }, [dispatch])

  return (
    <div>
      <p>{t('paymentHistory')}</p>
      <div className='account__list list'>
        {Array.isArray(data) && data?.length > 0
          ? data.map((item: PaymentHistoryItem) => <div
            key={item.id}
            className='list__element --big'
            onClick={() => {
              push(window.location.pathname, LOCATION_STATES.popup({ type: 'paymentHistoryItem', props: item.id }))
            }}>
            <div className='group'>
              <div>
                <div className='element__title'>
                  <i className={`icon paymentIcon icon--${item.status === 'CANCELLED' ? 'close' : item.status === 'FAILURE' ? 'payment-failed' : item.status === 'SUCCESS' ? 'payment-success' : 'payment-pending'}`} />
                  <span>{item.paymentMethodName}{item.title ? ` - ${item.title}` : ''}</span>
                </div>
                <div className='element__desc'>{displayPrice(item.amount)} <span className='dot' /> {toLongDate(item.date, lang)}</div>
              </div>
              <i className='icon icon--arrow-right-hide' />
            </div>
          </div>)
          : (status === STATUS.succeed || status === STATUS.failed)
            ? <div className='list__element --big'>
              <Error staticPos text={status === STATUS.succeed ? t('noPaymentHistory') : undefined} />
            </div>
            : <>
              <div className='list__element --big --skeleton'>
                <div className='group'>
                  <div>
                    <Skeleton className='skeleton__title' />
                    <Skeleton className='skeleton__desc' />
                  </div>
                </div>
              </div>
              <div className='list__element --big --skeleton'>
                <div className='group'>
                  <div>
                    <Skeleton className='skeleton__title' />
                    <Skeleton className='skeleton__desc' />
                  </div>
                </div>
              </div>
            </>}
      </div>
    </div>
  )
}

export default PaymentHistory